import {
  Sb_GetUniversalShoppingBasketByTokenQuery,
  Sb_GetUniversalShoppingBasketByTokenQueryVariables,
  Sb_GetUniversalShoppingBasketQuery,
  Sb_GetUniversalShoppingBasketQueryVariables,
} from '#src/generated/graphql';
import {
  SHOPPING_BASKET_NOT_FOUND_ERROR,
  hasBreakingFlowErrorCode,
  hasFeapiErrors,
} from '#src/utils';
import { useQuery } from '@edreamsodigeo/frontend-api-client';
import { useFrontendApiBlockingError } from '@edreamsodigeo/frontend-core';

import {
  GET_UNIVERSAL_SHOPPING_BASKET,
  GET_UNIVERSAL_SHOPPING_BASKET_BY_TOKEN,
} from './operations/ShoppingBasketProvider.queries';
import { ShoppingBasketHook } from './types';

const useCheckGetShoppingBasketErrors = ({ response, errors }) => {
  useFrontendApiBlockingError(response);

  if (
    hasBreakingFlowErrorCode(response.httpStatusCode) ||
    hasFeapiErrors(errors)
  ) {
    throw new Error(SHOPPING_BASKET_NOT_FOUND_ERROR);
  }
};

export const useGetShoppingBasketByIdParam = ({
  shoppingBasketId,
}: {
  shoppingBasketId: string;
}): ShoppingBasketHook => {
  const response = useQuery<
    Sb_GetUniversalShoppingBasketQuery,
    Sb_GetUniversalShoppingBasketQueryVariables
  >(GET_UNIVERSAL_SHOPPING_BASKET, {
    variables: {
      request: {
        shoppingBasketId: String(shoppingBasketId),
      },
    },
  });

  const { data, loading, errors } = response;

  useCheckGetShoppingBasketErrors({ response, errors });

  return {
    loading,
    ...data?.getUniversalShoppingBasket,
  } as ShoppingBasketHook;
};

export const useGetShoppingBasketByTokenParam = ({
  shoppingBasketId,
}: {
  shoppingBasketId: string;
}): ShoppingBasketHook => {
  const response = useQuery<
    Sb_GetUniversalShoppingBasketByTokenQuery,
    Sb_GetUniversalShoppingBasketByTokenQueryVariables
  >(GET_UNIVERSAL_SHOPPING_BASKET_BY_TOKEN, {
    variables: {
      request: {
        shoppingBasketToken: String(shoppingBasketId),
      },
    },
  });

  const { data, loading, errors } = response;

  useCheckGetShoppingBasketErrors({ response, errors });

  return {
    loading,
    ...data?.getUniversalShoppingBasketByToken,
  } as ShoppingBasketHook;
};
